import React, { useState } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Confirm, Message, Loader } from 'semantic-ui-react';
import AddButton from '../../components/Button/AddButton';

import { FlexContainer, FlexChildren } from '../../components/Dashboard/styles';
import Table from '../../components/Table';
import Modal from './Modal';
import { Header, Title, Container } from './styles';

import { GET_SERVICES_CONFIG } from '../../services/graphql/queries';
import { DELETE_SERVICE_CONFIG } from '../../services/graphql/mutations';

const columns = [
  { id: 'name', label: 'Nombre', minWidth: 100 },
  { id: 'one_time_day', label: 'Ejecución diaria', minWidth: 100 },
  { id: 'last_exec_time', label: 'Última ejecución', minWidth: 100 },
  { id: 'active', label: 'Activo', minWidth: 50 },
  { id: 'actions', label: 'Acciones', maxwidth: 30 }
];

export default function ServicesConfiguration() {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [selected, setSelected] = useState({});
  const [recordId, setRecordId] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const { loading, error, data, refetch } = useQuery(GET_SERVICES_CONFIG);

  const [deleteServiceConfig, { loading: deleteLoading }] = useMutation(
    DELETE_SERVICE_CONFIG
  );

  function handleEdit(data) {
    setEdit(true);
    setSelected(data);
    setOpen(true);
  }

  function handleAdd() {
    setEdit(false);
    setOpen(true);
  }

  function handleOnDeleteClick(id) {
    setRecordId(id);
    setConfirmationOpen(true);
  }

  function handleDelete() {
    deleteServiceConfig({ variables: { id: recordId } });
    setConfirmationOpen(false);
    refetch();
  }

  function handleModalClose() {
    refetch();
    setOpen(false);
  }

  return (
    <Container data-testid="services-configuration-component">
      <Confirm
        open={confirmationOpen}
        onCancel={() => setConfirmationOpen(false)}
        onConfirm={handleDelete}
        cancelButton="No"
        confirmButton="Si"
        header="Eliminar registro"
        content="¿Estás seguro de que deseas eliminar este registro?"
      />
      <FlexContainer>
        <FlexChildren>
          <Header>
            <Title>Configuración de Servicios</Title>
            <AddButton add onClick={handleAdd} />
          </Header>
          {(loading || deleteLoading) && (
            <>
              <br />
              <Loader active inline="centered" />
            </>
          )}
          {error && <Message error header="Error" content={error.message} />}
          {!loading && !error && data && (
            <Table
              data={data ? data.getLprConfig : null}
              columns={columns}
              handleEdit={handleEdit}
              handleDelete={handleOnDeleteClick}
            />
          )}
          <Modal
            open={open}
            onClose={handleModalClose}
            edit={edit}
            selected={selected}
          />
        </FlexChildren>
      </FlexContainer>
    </Container>
  );
}
